import { gql } from 'graphql-request';

export const ACCEPT_ALL_TASK_MEMBER_INVITES_QUERY = gql`
  mutation AcceptAllTaskMemberInvites($clientMutationId: String) {
    acceptAllTaskMemberInvites(input: { clientMutationId: $clientMutationId }) {
      status
    }
  }
`;
